import { createGlobalState } from 'react-hooks-global-state';
import EditBookingData from '../assets/data/edit_booking.json';
import { emptyDatesObject } from '../../../../availability_calendar/AvailabilityCalendar';

export const { GlobalStateProvider, useGlobalState } = createGlobalState({
  editBookingDetails: [],
  loadingCalenderDateAvailability: false,
  bookingId: null,
  // disabledDates: ["2021-04-29", "2021-04-30", "2021-05-5"],
  disabledDates: [new Date('2021, 1, 12')],
  bookingDates: [{ ...emptyDatesObject }],
  customSlotData: null,
  userSelectedBookingPackage: null,
  customPropertyDetails: null,
  taxiDetails: {
    taxi_booked: false,
    pickup_date: '',
    pickup_location: '',
    dropoff_date: '',
    dropoff_location: '',
  },
  availableTime: null,
  arrivalTime: null,
  isArrivalFixed: null,
  isDepartureFixed: null,
  departureTime: null,

  swimAvailableData: null,
  unSelectableSwimIds: [],

  lakeInfoList: null,
  lakeListInfo: null,
  userSelectedLakeName: null,
  userSelectedBookingType: null,
  userSelectedLakeId: null,
  userSelectedLakeInfo: null,
  userSelectedTicket: null,
  userSelectedSwims: [],
  userSelectedDoubleSwim: [],
  anglers: 10000,
  estimatedPricing: null,
  payableAmount: null,
  payment: 'card',
  userInputSwimBookerId: [{ value: '', loading: false }],
  userDetails: null,
  addedProductItem: [],
  productItem: [],
  userInputDetails: [
    {
      first_name: '',
      last_name: '',
      email: '',
      no_email: false,
      phone_number: '',
      profile_image: '',
      num_rod: 1,
      concession: false,
    },
  ],
  noOfTickets: [],
  userInputLabel: ['First Name', 'Last Name', 'Email', 'Phone Number'],
  guest: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  userInputName: ['first_name', 'last_name', 'phone_number', 'num_rod'],
  userSelectedAnglers: null,
  userSelectedGuests: null,
  notes: '',
  registration: '',
  loading: true,
  packageId: null,
  selectedArrival: undefined,
  selectedDeparture: undefined,

  // bookingId: null,
  // // disabledDates: ["2021-04-29", "2021-04-30", "2021-05-5"],
  // disabledDates: [new Date('2021, 1, 12')],
  // bookingDates: [
  //   {
  //     startDate: new Date('2021, 05, 11'),
  //     endDate: addDays(new Date('2021, 05, 11'), 3),
  //     key: 'selection',
  //     end_date: new Date('2021, 05, 14')
  //   }
  // ],

  // availableTime: AvailableTime,
  // arrivalTime: "2021-05-11 08:00:00",
  // departureTime: "2021-05-14 20:00:00",
  // swimAvailableData: null,
  // unSelectableSwimIds: [],
  // lakeInfoList: {
  //     "all_lakes": [{
  //       "id": "7ef199b1-c66b-41e2-9d77-b46e0715fbc8",
  //       "name": "Alpha Lake"
  //     }, {
  //       "id": "78980c03-8eb4-407d-bdf6-b2a1326537ac",
  //       "name": "Top Lake"
  //     }],
  //     "default": {
  //       "id": "7ef199b1-c66b-41e2-9d77-b46e0715fbc8",
  //       "name": "Alpha Lake"
  //     }
  // },
  // userSelectedLakeName: null,
  // userSelectedLakeId: null,
  // userSelectedSwims: [],
  // userSelectedDoubleSwim: [],
  // anglers: 3,
  // estimatedPricing: {
  //   "amount": 58,
  //   "currency": "GBP"
  // },
  // userInputSwimBookerId: null,
  // userDetails: AnglerDetails,
});
